import Enumerator from '../global/Enumerator';

export const objectivePaymentPreferenceOptions = [
  'none',
  'advance',
  'arrears',
  'not_important'
];

export class ObjectivePaymentPreferenceOption extends Enumerator {
  static default() {
    return this.of('none');
  }

  static of(option?: string) {
    let correctOption = option;
    switch (option) {
      case '1':
        correctOption = 'advance';
        break;
      case '2':
        correctOption = 'arrears';
        break;
      case '3':
        correctOption = 'not_important';
        break;
      default:
        break;
    }
    return this.enumValueOf(correctOption) || this.default();
  }
}

ObjectivePaymentPreferenceOption.initEnum(objectivePaymentPreferenceOptions);

export default {
  objectivePaymentPreferenceOptions,
  ObjectivePaymentPreferenceOption
};
